import PropTypes from 'prop-types'
import BasicObject from 'model/basicObject'
import { isNil } from 'ramda'

class TicketTypeGroup extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> TicketTypeGroup constructor -', init)
    if (isNil(init)) return undefined
    this._code = init.code
    this._enable_task_manager = init.enable_task_manager
    this._display_name = init.display_name
  }

  static shape = {
    id: PropTypes.string.isRequired,
    code: PropTypes.string,
    enable_task_manager: PropTypes.bool
  }

  get code() {
    return this._code
  }

  get display_name() {
    return this._display_name
  }

  get enable_task_manager() {
    return this._enable_task_manager
  }

  // Calculable
  get isTaskManagerEnabled() {
    return !!this.enable_task_manager
  }
}

export default TicketTypeGroup
